import {NatGetClosedSetting} from './NatGetClosedSetting'
import {NatPostClosedSetting, NatPostClosedSettingParams} from './NatPostClosedSetting'
import Http from '../../../../network/Http'
import {SortOrder} from '../../../../components/shared/SortOrder'
import {ContentType} from '../../../../network/Constants'
import {SearchConditionPageInfo} from '../../message/repository/NatGetMessageList'

export interface SearchCondition {
    getNoClosedSettingFacilityFlag?: string
    pageNum?: string
    page?: string
}

export default class NatClosedSettingRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    // 休館設定一覧取得
    async getClosedSetting(
        searchCondition?: SearchCondition,
        searchConditionPageInfo?: SearchConditionPageInfo,
        searchConditionSortInfos?: SortOrder[],
    ): Promise<NatGetClosedSetting> {

        const searchParams: string[] = []
        if (searchCondition) {
            if (searchCondition.getNoClosedSettingFacilityFlag) {
                searchParams.push(`getNoClosedSettingFacilityFlag=${encodeURIComponent(searchCondition.getNoClosedSettingFacilityFlag)}`)
            }
            if (searchCondition.pageNum) {
                searchParams.push(`pageNum=${encodeURIComponent(searchCondition.pageNum)}`)
            }
            if (searchCondition.page) {
                searchParams.push(`page=${encodeURIComponent(searchCondition.page)}`)
            }
        }
        if (searchConditionPageInfo) {
            if (searchConditionPageInfo.pageNum) {
                searchParams.push(`pageNum=${encodeURIComponent(searchConditionPageInfo.pageNum)}`)
            }
            if (searchConditionPageInfo.page) {
                searchParams.push(`page=${encodeURIComponent(searchConditionPageInfo.page)}`)
            }
        }
        if (searchConditionSortInfos) {
            searchConditionSortInfos.forEach((sortInfo) => {
                const value: string = encodeURIComponent(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
                searchParams.push(`sortInfo=${value}`)
            })
        }

        const searchParamsText: string = searchParams.join('&')
        return await this.http.get(`/api/admin/closedSetting?${searchParamsText}`)
    }

    // 休館設定一括反映
    async postClosedSetting(requestParams: NatPostClosedSettingParams): Promise<NatPostClosedSetting> {
        return await this.http.post(
            `/api/admin/closedSetting`,
            {
                registerClosedSetting: requestParams.registerClosedSetting,
                updateClosedSetting: requestParams.updateClosedSetting,
                deleteClosedSetting: requestParams.deleteClosedSetting,
            },
            ContentType.JSON,
        )
    }

    async registerClosedSetting(requestParams: NatPostClosedSettingParams): Promise<void> {
        return await this.http.post(
            `/api/admin/registerClosedSetting`,
            {
                registerClosedSetting: requestParams.registerClosedSetting,
                updateClosedSetting: requestParams.updateClosedSetting,
                deleteClosedSetting: requestParams.deleteClosedSetting,
            },
            ContentType.JSON,
        )
    }
}
